var $body = $('body');
document.addEventListener('lazybeforeunveil', function (e) {
  var bg = e.target.getAttribute('data-bg');
  if (bg) {
    e.target.style.backgroundImage = 'url(' + bg + ')';
  }
});

$(document).ready(function () {

  // code for wow initialize
  wow = new WOW({
    // mobile: false
  });
  wow.init();

  //News carousel
  var newsBannerSlider = $('.news-slider');
  if (newsBannerSlider.length) {
    if (newsBannerSlider.find('.news-slide').length > 1) {
      newsBannerSlider.owlCarousel({
        items: 1,
        nav: true,
        dots: true,
        autoHeight: true,
        lazyLoad: true,
        loop: true,
        onInitialize: function () {
          if (newsBannerSlider.find('.news-slide').length === 1) {
            this.settings.loop = false;
            this.settings.nav = false;
          }
        }
      });
    } else {
      newsBannerSlider.show();
    }
  }

  //news-overlay-slider
  $(".news-overlay-slider").each(function () {
    var newsTwoColSlider = $(this);
    if (newsTwoColSlider.length) {
      if (newsTwoColSlider.find('.news-overlay-slide').length > 1) {
        newsTwoColSlider.owlCarousel({
          items: 1,
          nav: true,
          dots: false,
          autoHeight: true,
          lazyLoad: true,
          autoplay: true,
          loop: true,
          onInitialize: function () {
            if (newsTwoColSlider.find('.news-overlay-slide').length === 1) {
              $(this).settings.loop = false;
              $(this).settings.nav = false;
            }
          }
        });
      } else {
        newsTwoColSlider.show();
      }
    }
  });

  //postSlider
  var postSlider = $('.related-post-slider');
  if (postSlider.length) {
    if (postSlider.find('.related-post-slide').length > 1) {
      postSlider.owlCarousel({
        nav: true,
        dots: false,
        margin: 20,
        autoplay: true,
        loop: true,
        responsiveClass: true,
        responsive: {
          0: {
            items: 1
          },
          576: {
            items: 2
          },
          992: {
            items: 3
          }
        }
      });
    } else {
      postSlider.show();
    }
  }

  //partner-slider
  var asidePartnerSlider = $('.partner-slider-init');
  if (asidePartnerSlider.length) {
    if (asidePartnerSlider.find('.partner-slide').length > 1) {
      asidePartnerSlider.owlCarousel({
        items: 1,
        nav: false,
        dots: true,
        autoplay: true,
        loop: true,
        onInitialize: function () {
          if (asidePartnerSlider.find('.partner-slide').length === 1) {
            this.settings.loop = false;
            this.settings.dots = false;
          }
        }
      });
    } else {
      asidePartnerSlider.show();
    }
  }

  // Social icons
  if ($('.news-more').length) {
    $('.btn-share-icon').on('click', function () {
      $(this).parent('.news-more').parents().siblings().find('.news-more').removeClass('news-share--open');
      $(this).parent('.news-more').toggleClass('news-share--open');
    });
  }

  //Mobile Menu
  $('.menu-trigger').on('click', function () {
    $('body').toggleClass('menu--open');
    nav_height();
  });

  //Nav trigger
  $('.nav-arrow').on('click', function () {
    $(this).parent().siblings('li.has-sub-menu').removeClass('sub--open').find('ul').slideUp();
    $(this).parent().toggleClass('sub--open').find('ul').first().slideToggle();
  });

  // Go to top
  $(".goto-top").on('click', function () {
    $("html, body").animate({ scrollTop: 0 }, 1000);
    return false;
  });

  // Search on navigation
  $('.search-btn').on('click', function () {
    $('.navigation').toggleClass('search-show');
  });
});

$(window).resize(function () {
  nav_height();
  isotope_masonry();
});

var stickyOffset = $('header').height();
var previousScroll = 0;
$(window).scroll(function () {
  var scroll = $(window).scrollTop();

  // Fixed Menu
  if (scroll >= 100) {
    $('body').addClass('fixed-header');
  } else {
    $('body').removeClass('fixed-header');
  }

  /* for go to top arrow */
  var currentScroll = $(this).scrollTop();
  if (currentScroll > previousScroll) {
    if (scroll >= stickyOffset + 100) {
      $('.goto-top').addClass('visible');
    }
  } else {
    $('.goto-top').removeClass('visible');
  }
});

$(window).on('load', function () {
  //Preloader JS code
  setTimeout(remove_loader, 700);

  /*isotope_masonry Function*/
  isotope_masonry();
  setDefaultDirection();

  // bind sort button click
  $('.asc-desc').on('click', function () {
    var sortValue = $(this).attr('data-sort-value');
    $(this).toggleClass("on");
    var direction = $(this).attr('data-sort-direction');
    /* convert it to a boolean */
    var isAscending = (direction === 'desc');
    var newDirection = (isAscending) ? 'asc' : 'desc';
    /* pass it to isotope */
    $workGrid.isotope({
      sortBy: sortValue,
      sortAscending: isAscending
    });
    $(this).attr('data-sort-direction', newDirection);
  });
});
var DELAY = 500,
  clicks = 0,
  timer = null;

function isTouchDevice() {
  return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
}
$(document).on("click", ".has-sub-menu > a", function (e) {
  if (isTouchDevice() === true && (window.matchMedia('(min-width: 993px)').matches) && (window.matchMedia('(max-width: 1200px)').matches)) {
    console.log('yes');
    clicks++;
    if (clicks === 1) {
      timer = setTimeout(function () {
        clicks = 0;
      }, DELAY);
      e.preventDefault();
    } else {
      clearTimeout(timer);
      clicks = 0;
    }
  }
}).on("dblclick", function (e) { });
function nav_height() {
  if (window.matchMedia('(min-width: 991px)').matches) {
    $('.navigation').css('min-height', 'auto');
    $('.navigation').css('margin-top', 0);
  } else {
    $('.navigation').css('min-height', win_height() - header_height() + 1);
    $('.navigation').css('margin-top', header_height() - 1);
  }
}
/*isotope_masonry Function*/
function isotope_masonry() {
  //portfolio Isotope plugins initialize
  if ($('.news-grid ').length) {
    // init Isotope
    $workGrid = $('.news-grid ').isotope({
      itemSelector: '.news-grid-item',
      layoutMode: "packery",
      getSortData: {
        name: '.news-title'
      }
    });
    var $img = $('img');
    $workGrid.imagesLoaded(function () {
      $img.on('load', function () {
        $workGrid.isotope('layout');
      });
    });
    // filter items on button click
    $('.js-filter').on('click', 'button', function () {
      var filterValue = $(this).attr('data-filter');
      $workGrid.isotope({
        filter: filterValue
      });
      $('.js-filter button').removeClass('is-active');
      $(this).addClass('is-active');
    });
  }
}
function setDefaultDirection() {
  var sortValue = $('.asc-desc').attr('data-sort-value');
  var direction = $('.asc-desc').attr('data-sort-direction');
  $('.news-grid ').isotope({
    sortBy: sortValue,
    sortAscending: direction
  });
}
function win_height() {
  return $(window).outerHeight();
}

function win_width() {
  return $(window).width();
}

function header_height() {
  return $('header.page').outerHeight();
}

function remove_loader() {
  $('.preloader').hide();
}
